import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  TributacaoCfopCadastroDto,
  TributacaoCfopCadastroImpostoDto,
  TributacaoCfopCadastroSchema,
} from "./TributacaoCfopCadastro.Dto";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import {
  TributacaoCfopAtualizar,
  TributacaoCfopBuscarId,
  TributacaoCfopIncluir,
  TributacaoMensagemFiltrar,
} from "src/services/Fiscal.Service";
import { IRoute } from "src/interfaces/IRoute";
import { ConsultarCategoria } from "src/hook/Consulta/ConsultaCategoria.Module";
import { CategoriaBuscarPorId } from "src/services/Estoque.Service";
import { showToast } from "src/componentes";
import { TributacaoMensagemDto } from "../Mensagem/TributacaoMensagem.Dto";

const TributacaoCfopCadastroCode = () => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [incluir, setIncluir] = useState(false);
  const navigate = useNavigate();
  const id = searchParams.get("id");
  const tributacaoid = searchParams.get("tributacaoid");
  const [data, setData] = useState<
    TributacaoCfopCadastroImpostoDto[] | undefined
  >([]);
  const [mensagens, setMensagens] = useState<TributacaoMensagemDto[]>([]);
  const [menuItens, setMenuItens] = useState<IRoute[]>([]);
  const [selectedParametroValor, setSelectedParametroValor] =
    useState<string>("");

  const form = useForm<TributacaoCfopCadastroDto>({
    resolver: yupResolver(TributacaoCfopCadastroSchema),
    defaultValues: { parametroValor: 0, mensagemId: "" as any },
  });

  const consultarCategoria = ConsultarCategoria();

  useEffect(() => {
    TributacaoMensagemFiltrar({})
      .then((responseMensagem) => {
        if (responseMensagem.data.success) {
          const result = Array.isArray(responseMensagem.data.data)
            ? responseMensagem.data.data
            : responseMensagem.data.data
            ? [responseMensagem.data.data]
            : [];
          setMensagens(result);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      try {
        if (id) {
          setLoading(true);
          const response = await TributacaoCfopBuscarId(id);
          if (response.data.success) {
            const data = response.data.data;
            setSelectedParametroValor(data.tipoParametro.toString());

            if (data.tipoParametro === 1) {
              const categoriaresponse = await CategoriaBuscarPorId(
                data.parametroValor.toString(),
              );
              if (categoriaresponse.data.success) {
                const categoriaData = categoriaresponse.data.data;
                data.categoriaNome = categoriaData.nome;
              } else {
                showToast({
                  message: "Ocorreu erro ao carregar Categoria",
                  title: "Erro",
                  variant: "Danger",
                });
              }
            }

            if (data.mensagemId !== undefined && data.mensagemId !== null) {
              data.mensagemId = data.mensagemId.toString();
            } else {
              data.mensagemId = "";
            }

            form.reset(data);

            setIncluir(false);
            setData(data.impostos);
            setMenuItens([
              {
                name: "Novo ICMS...",
                route: `/fiscal/tributacao/cfop/imposto/cadastro?type=0&tributacaocfopid=${id}`,
              },
              {
                name: "Novo IPI...",
                route: `/fiscal/tributacao/cfop/imposto/cadastro?type=1&tributacaocfopid=${id}`,
              },
              {
                name: "Novo PIS...",
                route: `/fiscal/tributacao/cfop/imposto/cadastro?type=2&tributacaocfopid=${id}`,
              },
              {
                name: "Novo COFINS...",
                route: `/fiscal/tributacao/cfop/imposto/cadastro?type=3&tributacaocfopid=${id}`,
              },
              {
                name: "Novo IBS/CBS...",
                route: `/fiscal/tributacao/cfop/imposto/ibscbs/cadastro?type=4&tributacaocfopid=${id}`,
              },
            ]);
          } else {
            showToast({
              message: "Ocorreu erro ao carregar TributacaoCfop",
              title: "Erro",
              variant: "Danger",
            });
          }
        } else {
          setIncluir(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [id]);

  const onSubmit = async (data: TributacaoCfopCadastroDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    data.tributacaoId = Number(tributacaoid);
    data.tipoParametro = Number(data.tipoParametro);
    data.parametroValor = Number(data.parametroValor);
    data.mensagemId =
      data.mensagemId && Number(data.mensagemId) > 0
        ? Number(data.mensagemId)
        : null;

    if (incluir === true) {
      TributacaoCfopIncluir(data)
        .then((response) => {
          if (response.data.success) {
            navigate(`/fiscal/tributacao/cadastro?id=${tributacaoid}`);
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError,
            );
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      data.id = Number(id);
      data.tributacaoId = Number(tributacaoid);
      data.tipoParametro = Number(data.tipoParametro);
      data.parametroValor = Number(data.parametroValor);
      data.mensagemId =
        data.mensagemId && Number(data.mensagemId) > 0
          ? Number(data.mensagemId)
          : null;

      TributacaoCfopAtualizar(data)
        .then((response) => {
          if (response.data.success) {
            navigate(`/fiscal/tributacao/cadastro?id=${tributacaoid}`);
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError,
            );
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const getOptions = () => {
    return [
      { value: "", label: "Selecione" },
      { value: "0", label: "Todos" },
      { value: "1", label: "Categoria Id" },
    ];
  };

  const getMensagemOptions = () => {
    return [
      { value: "", label: "Selecione" },
      ...mensagens.map((item) => ({
        value: item.id.toString(),
        label: item.mensagem,
      })),
    ];
  };

  return {
    loading,
    onSubmit,
    form,
    incluir,
    data,
    menuItens,
    setSelectedParametroValor,
    selectedParametroValor,
    getOptions,
    getMensagemOptions,
    mensagens,
    consultarCategoria,
  };
};
export default TributacaoCfopCadastroCode;
